import { ajax } from "../settings/settings";

export const getPromo = callback => {
  ajax
    .get("/web/rest/promo")
    .then(function(response) {
      if (response) {
        if (callback) {
          callback(response);
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};
